// Pure display helpers for the AI analysis jobs table. No Vue, no store, no '@/' imports:
// these run under `node --test` as well as in the browser bundle.

export const EM_DASH = '\u2014';

const MS_PER_MINUTE = 60000;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;
const SHORT_ID_LENGTH = 6;

/** "25 min ago" / "2 h 50 min ago" / "3 d ago"; empty when the date is unusable. */
export function formatRelative(iso, now = Date.now()) {
  const started = new Date(iso || '').getTime();
  if (!Number.isFinite(started)) return '';
  const minutes = Math.max(0, Math.round((now - started) / MS_PER_MINUTE));
  if (minutes < MINUTES_PER_HOUR) return `${minutes} min ago`;
  const hours = Math.floor(minutes / MINUTES_PER_HOUR);
  if (hours < HOURS_PER_DAY) return `${hours} h ${minutes % MINUTES_PER_HOUR} min ago`;
  return `${Math.floor(hours / HOURS_PER_DAY)} d ago`;
}

/** One line per cell (data-table rule 05): first scan name plus a "+n" overflow; `all` feeds the tooltip. */
export function scanSummary(scanNames) {
  const names = (scanNames || []).filter(Boolean);
  return { first: names[0] || EM_DASH, extra: Math.max(0, names.length - 1), all: names.join(', ') };
}

/** UserVM (firstName/lastName/email) or a plain string; a dash when nothing is usable. */
export function userDisplayName(user) {
  if (!user) return EM_DASH;
  if (typeof user === 'string') return user || EM_DASH;
  const full = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return full || user.email || user.userName || EM_DASH;
}

export function shortJobId(id) {
  const head = String(id || '').slice(0, SHORT_ID_LENGTH).toUpperCase();
  return `JOB-${head || EM_DASH}`;
}

/** Case-insensitive match over the job, its scans, its group and its author. Empty term matches everything. */
export function jobMatchesSearch(job, group, term) {
  const needle = String(term || '').trim().toLowerCase();
  if (!needle) return true;
  const haystack = [
    job.title,
    job.id,
    ...(job.scanNames || []),
    group && group.title,
    group && group.subtitle,
    userDisplayName(job.createdBy),
  ];
  return haystack.some((value) => String(value || '').toLowerCase().includes(needle));
}
